"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const AddPlusIcon_1 = tslib_1.__importDefault(require("src/components/buttons/AddPlusIcon"));
const DeleteIconRound_1 = tslib_1.__importDefault(require("src/components/buttons/DeleteIconRound"));
const AssignSubmissionProjectsAddOrRemove = (props) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'd-flex justify-content-end align-items-center w-100', children: [props.projectInfos.length > 1 && !props.disabledStatus
                ? (0, jsx_runtime_1.jsx)(DeleteIconRound_1.default, { onClick: props.setProjectInfos }) : null, props.projectInfos.length === props.projectInfoIndex + 1 && !props.disabledStatus
                ? ((0, jsx_runtime_1.jsx)(AddPlusIcon_1.default, { onClick: props.setFieldValue })) : null] }));
};
exports.default = AssignSubmissionProjectsAddOrRemove;
